import { TTheme } from '@types'

export const darkTheme: TTheme = {
    theme: 'acs-dark',
    variables: {
        colorPrimary: '#57023D',
        colorBackground: '#000000',
        colorText: '#ffffff',
        colorGray: {
            primary: '#959595',
            secondary: '#ebebeb',
        },
        colorDanger: {
            primary: '#F90215',
            secondary: '#232323',
        },
        colorWarning: {
            primary: '#F6851B',
            secondary: '#232323',
        },
        fontFamily: {
            headline: 'Work Sans, system-ui, sans-serif',
            title: 'Work Sans, system-ui, sans-serif',
            description: 'Work Sans, system-ui, sans-serif',
            text: 'Work Sans, system-ui, sans-serif',
        },
        badgeColor: {
            primary: '#00bcd4',
            secondary: '#ff9800',
            success: '#4caf50',
            warning: '#ff9800',
            danger: '#f44336',
            info: '#2196f3',
            light: '#f4f4f4',
            dark: '#212121',
        },
        borderRadius: '100px',
        boxShadow: '0 0 0 0.25rem rgb(87 2 61 / 50%)',
        lineBorder: '#272727',
    },
}
